/**
 * @file 开始使用页快速安装hooks
 * @author FengGuang(fengguang01@baidu.com)
 */
import { useEffect, useMemo, useState } from 'react';

import useQuickStartHooks from '../../components/quick-start/quickStartHooks';
import {
    fetchGetFastDeployInstall,
} from '../../../../api/pages/installApi';
import { IQuickStartItem } from '../../components/quick-start/type';

const useQuickHooks = () => {
    const localStorageName = 'quickInstallFastDeployChecked';
    const quickStartHooks = useQuickStartHooks(localStorageName);

    const [suffixText, setSuffixText] = useState<string>('');

    // 获取快速安装选择器数据
    // const qiShowItem = quickStartHooks.showItem;
    const qsSetChecked = quickStartHooks.setChecked;
    const qsSetQuickInstallList = quickStartHooks.setQuickInstallList;
    const qsSetQuickInstallSelector = quickStartHooks.setQuickInstallSelector;

    const resJson = localStorage.getItem(localStorageName);
    const resArray: string[] = useMemo(() =>
        resJson ? JSON.parse(resJson) : []
        , [resJson]);

    useEffect(() => {
        (async () => {
            const res = await fetchGetFastDeployInstall()
                .catch(() => {});
            if (res) {
                const data = res.body.result?.pageData || {};

                const qi: any = data.quickInstall || {};
                const qiGroup: any[] = Array.isArray(qi.group) ? qi.group : [];
                const qiList: any[] = Array.isArray(qi.list) ? qi.list : [];

                // 选项
                const resGroup = qiGroup.map(groupItem => {
                    const list: any[] = Array.isArray(groupItem.list) ? groupItem.list : [];
                    return {
                        groupName: groupItem.groupName,
                        groupKey: groupItem.groupKey || groupItem.groupName,
                        disabledTooltip: groupItem.disabledTooltip,
                        tips: groupItem.tips,
                        list: list.map(item => ({
                            id: `${groupItem.groupName}${item.optionName}${item.optionKey}`,
                            groupName: groupItem.groupName,
                            groupKey: groupItem.groupKey || groupItem.groupName,
                            optionName: item.optionName,
                            optionKey: item.optionKey
                        }))
                    };
                });
                // 可选的结果列表
                const resQiList: IQuickStartItem[] = qiList.map(item => {
                    const theContext: any[] = Array.isArray(item.context) ? item.context : [];
                    return {
                        index: item.index,
                        indexSet: typeof (item.index) === 'string' ? new Set<string>(item.index.split(',')) : new Set<string>(),
                        context: theContext.map((citem) => ({
                            title: citem.title,
                            text: citem.text
                        })),
                        linkEn: item.linkEn,
                        linkZh: item.linkZh
                    };
                });

                // 一定要先设置选中项 checked，再设置可选列表 qiList。
                // 因为选中项会从localstorage读取默认值，先设置可选项，再判断一次默认值，可能导致监听选中结果的effect多执行一次

                // 快速安装默认选中的项目
                const qiDefaultChecked = qi.defaultSelectedKey ? qi.defaultSelectedKey.split(',') : [];
                const existKey = new Set();
                resGroup.forEach((group) => {
                    group.list.forEach((item) => {
                        existKey.add(item.optionKey);
                    });
                });
                qsSetChecked((old) => {
                    const def = old.filter(k => existKey.has(k));
                    return (
                        def.length > 0 ? def : qiDefaultChecked
                    );
                });
                qsSetQuickInstallList(resQiList);
                qsSetQuickInstallSelector(resGroup);

                // 设置后缀文案
                const st = qi.suffixText || '';
                setSuffixText(st);
            }
        })();
    }, [qsSetQuickInstallList, qsSetChecked, qsSetQuickInstallSelector, resArray]);

    return {
        quickStartHooks,
        suffixText
    };
};

export default useQuickHooks;
